export const AGE_I18N_KEY = 'pages.patients.selectedPatient.header.age'
export const AGE_NO_BIRTHDATE_I18N_KEY = 'pages.patients.selectedPatient.header.ageNoBirthdate'

/**
 * Decides how the patient-card age label should render.
 * - With a birthdate: the full "Age: <age> (<date>)" template.
 * - Without a birthdate: the "Age: <age or N/A>" template. Covers records-only
 *   patients that never got a DOB, and patients that only have an ageRange.
 *
 * @param {Object} params
 * @param {boolean} params.hasBirthdate whether the patient has a stored DOB
 * @param {(string|number)} [params.age] resolved age (from DOB) or ageRange
 * @param {string} params.naText localized "N/A" fallback text
 * @returns {{ i18nKey: string, age: (string|number) }}
 */
export const getAgeHeaderDisplay = ({ hasBirthdate, age, naText }) => ({
  i18nKey: hasBirthdate ? AGE_I18N_KEY : AGE_NO_BIRTHDATE_I18N_KEY,
  age: age ?? naText
})
